import { SearchFormState } from '../reducers';
import { Location } from '../../../LocationAutocomplete/types';

export const getRecentSearches = (state: SearchFormState): Location[] => state.recentSearches;
